import QRCode from 'react-qr-code';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_josmart-staging/artifacts/r0wcvy09_file_00000000fee871f598adf429b9fe9c58.png";
const SIGNATURE_URL = "https://customer-assets.emergentagent.com/job_436ba06e-6ded-43b8-804c-6808497cf3c1/artifacts/scbiof2b_IMG-20260326-WA0062.jpg";

export default function CertificatePreview() {
  const certData = {
    recipientName: "Jean-Baptiste Mukendi",
    formationTitle: "Gagner de l'argent avec le Marketing Digital",
    skills: ["Marketing Digital", "SEO", "Strategie Digitale", "Reseaux Sociaux"],
    completionDate: "17 avril 2026",
    certificateId: "JST-2026-00172",
    verifyUrl: "josmartech.net/certificat/JST-2026-00172",
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4 sm:p-8">
      <CertificateCard cert={certData} />
    </div>
  );
}

export function CertificateCard({ cert }) {
  return (
    <div className="relative w-full max-w-[850px] aspect-[1/1.05] overflow-hidden rounded-2xl shadow-2xl"
      style={{ background: 'linear-gradient(160deg, #0a1628 0%, #0d2847 20%, #1a4a8a 50%, #2563aa 75%, #0d2847 100%)' }}
    >
      {/* Inner border */}
      <div className="absolute inset-3 sm:inset-5 border border-white/10 rounded-xl pointer-events-none" />
      {/* Corner accents */}
      <div className="absolute top-3 left-3 sm:top-5 sm:left-5 w-8 h-8 border-t-2 border-l-2 border-[#4A90D9]/40 rounded-tl-lg" />
      <div className="absolute top-3 right-3 sm:top-5 sm:right-5 w-8 h-8 border-t-2 border-r-2 border-[#4A90D9]/40 rounded-tr-lg" />
      <div className="absolute bottom-3 left-3 sm:bottom-5 sm:left-5 w-8 h-8 border-b-2 border-l-2 border-[#4A90D9]/40 rounded-bl-lg" />
      <div className="absolute bottom-3 right-3 sm:bottom-5 sm:right-5 w-8 h-8 border-b-2 border-r-2 border-[#4A90D9]/40 rounded-br-lg" />

      {/* Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <p className="text-white/[0.06] font-bold tracking-[0.15em] whitespace-nowrap rotate-[-30deg]"
          style={{ fontSize: 'clamp(120px, 20vw, 220px)' }}>
          JoSmartTech
        </p>
      </div>

      {/* Glow effects */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[60%] h-[30%] bg-[#4A90D9]/10 rounded-full blur-[80px]" />
      <div className="absolute bottom-0 left-0 w-[40%] h-[30%] bg-[#8B5CF6]/8 rounded-full blur-[60px]" />

      <div className="relative z-10 h-full flex flex-col px-8 sm:px-14 py-7 sm:py-10">
        {/* Header: Logo + Certified badge */}
        <div className="flex items-center justify-between mb-6 sm:mb-8">
          <div className="flex items-center gap-2.5">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-[#1a3a6a]/60 border border-white/10 flex items-center justify-center">
              <img src={LOGO_URL} alt="JoSmartTech" className="w-7 h-7 sm:w-8 sm:h-8 object-contain" style={{ filter: 'brightness(1.5)' }} />
            </div>
            <div>
              <p className="text-white font-bold text-sm sm:text-base tracking-wide">JoSmartTech</p>
              <p className="text-white/30 text-[8px] sm:text-[9px] tracking-[0.25em] uppercase">Digital Solutions</p>
            </div>
          </div>
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-[#1a3a6a]/50 border border-[#4A90D9]/30 rounded-lg">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" stroke="#4A90D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            <div>
              <p className="text-[#4A90D9] text-[9px] sm:text-[10px] font-bold uppercase tracking-wider">Certifie</p>
              <p className="text-white/30 text-[7px] sm:text-[8px] uppercase tracking-wider">Certified</p>
            </div>
          </div>
        </div>

        {/* Title section */}
        <div className="text-center flex-1 flex flex-col justify-center -mt-4">
          <p className="text-white/30 text-[9px] sm:text-[10px] tracking-[0.5em] uppercase mb-2">Certificat de Competence</p>
          <h1 className="text-2xl sm:text-4xl font-bold text-white mb-5 sm:mb-6">Certificat de Reussite</h1>

          <p className="text-white/40 text-xs sm:text-sm mb-1.5">Ce certificat est delivre a</p>
          <h2 className="text-xl sm:text-3xl font-bold text-white mb-4 sm:mb-5">{cert.recipientName}</h2>

          <p className="text-white/40 text-xs sm:text-sm mb-1.5">Pour avoir complete avec succes la formation</p>
          <p className="text-lg sm:text-xl font-bold text-white mb-5 sm:mb-6">{cert.formationTitle}</p>

          {/* Skills */}
          <div className="flex flex-wrap gap-2 justify-center mb-5 sm:mb-6">
            {(cert.skills || []).map((skill, i) => (
              <span key={i} className="px-3 sm:px-4 py-1 sm:py-1.5 rounded-full text-[10px] sm:text-xs font-medium border border-white/15 text-white/70 bg-white/[0.04]">
                {skill}
              </span>
            ))}
          </div>
        </div>

        {/* Bottom section: Date/ID + QR + Signature */}
        <div>
          {/* Date & ID */}
          <div className="mb-4 sm:mb-5">
            <p className="text-white/60 text-xs sm:text-sm">
              Certifie le : <span className="text-white font-semibold">{cert.completionDate || (cert.issued_at ? new Date(cert.issued_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : '')}</span>
            </p>
            <p className="text-white/40 text-[10px] sm:text-xs mt-0.5">ID certificat : {cert.certificateId || cert.certificate_id}</p>
          </div>

          {/* QR + Signature row */}
          <div className="flex items-end justify-between gap-4">
            {/* QR Code */}
            <div>
              <div className="bg-white p-1.5 sm:p-2 rounded-lg inline-block">
                <QRCode value={`https://${cert.verifyUrl || cert.verify_url || ''}`} size={55} bgColor="#ffffff" fgColor="#0a1628" />
              </div>
              <p className="text-white/30 text-[7px] sm:text-[8px] mt-1">Verifiez ce certificat :</p>
              <p className="text-[#4A90D9] text-[7px] sm:text-[8px] font-mono">{cert.verifyUrl || cert.verify_url}</p>
            </div>

            {/* Signature block */}
            <div className="text-right">
              <img
                src={SIGNATURE_URL}
                alt="Signature Jonathan Ngamba"
                className="w-40 sm:w-52 h-auto ml-auto rounded-lg"
                loading="lazy"
              />
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-4 sm:mt-5 pt-3 border-t border-white/5 text-center">
            <p className="text-white/20 text-[7px] sm:text-[8px] leading-relaxed">
              Ce certificat est une <span className="font-bold text-white/30">CERTIFICATION INTERNE</span> delivree par JoSmartTech. Les certificats delivres par JoSmartTech sont des attestations internes de formation et ne constituent pas des diplomes officiels reconnus par les institutions academiques ou gouvernementales.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
